import { render, staticRenderFns } from "./CelularDetalhado.vue?vue&type=template&id=6bfdb545&scoped=true&"
import script from "./CelularDetalhado.vue?vue&type=script&lang=js&"
export * from "./CelularDetalhado.vue?vue&type=script&lang=js&"
import style0 from "./CelularDetalhado.vue?vue&type=style&index=0&id=6bfdb545&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfdb545",
  null
  
)

export default component.exports